<template>
  <template-form
    :label="interviewCheckpointCategories.find(checkpointCategory => checkpointCategory.id === checkpointCategoryId).name + checkpointItemLabel"
    :required="checkpointRequired"
    :has-child="true"
    :data-test="`checkpoint-label-${checkpointCategoryId}`"
  >
    <div class="display-flex">
      <div class="pega-interview-left-content">
        <div
          v-for="checkpointDetail in checkpointDetails"
          :key="checkpointDetail.checkpointNo"
          class="boss-table-2-item boss-table-2-item-body"
        >
          <div :data-test="`checkpoint-title-label-${checkpointCategoryId}-${checkpointDetail.checkpointNo}`">
            {{ checkpointPrefixLabel }}{{ checkpointDetail.checkpointNo }}の概要（{{ maxLength.summary }}文字以内）
          </div>
          <input
            :value="checkpointDetail.summary"
            type="text"
            class="boss-input boss-input-fill"
            :class="{ 'is-invalid-input': isInvalidSummary(checkpointDetail.summary) || isInvalidSet(checkpointDetail.summary ,checkpointDetail.contents) }"
            :data-test="`checkpoint-title-${checkpointCategoryId}-${checkpointDetail.checkpointNo}`"
            @change="changed(checkpointCategoryId,checkpointDetail.checkpointNo,$event.target.value,checkpointDetail.contents)"
          >
          <validation-label
            v-if="isInvalidSummary(checkpointDetail.summary)"
            :data-test="`validation-summary-${checkpointCategoryId}-${checkpointDetail.checkpointNo}`"
            :label="`${maxLength.summary}文字以内で入力してください`"
          />
          <div :data-test="`checkpoint-reason-label-${checkpointCategoryId}-${checkpointDetail.checkpointNo}`">
            {{ checkpointPrefixLabel }}{{ checkpointDetail.checkpointNo }}{{
              checkpointReasonSuffixLabel
            }}（{{ maxLength.contents }}文字以内）
          </div>
          <textarea
            :value="checkpointDetail.contents"
            :data-test="`checkpoint-reason-${checkpointCategoryId}-${checkpointDetail.checkpointNo}`"
            rows="6"
            :class="{ 'is-invalid-input': isInvalidContents(checkpointDetail.contents) || isInvalidSet(checkpointDetail.summary ,checkpointDetail.contents) }"
            class="pega-interview-text-area pega-textarea-resize-none"
            @change="changed(checkpointCategoryId,checkpointDetail.checkpointNo,checkpointDetail.summary,$event.target.value)"
          />
          <validation-label
            v-if="isInvalidContents(checkpointDetail.contents)"
            :data-test="`validation-contents-${checkpointCategoryId}-${checkpointDetail.checkpointNo}`"
            :label="`${maxLength.contents}文字以内で入力してください`"
          />
          <validation-label
            v-if="isInvalidSet(checkpointDetail.summary ,checkpointDetail.contents)"
            :data-test="`validation-checkpoint-set-${checkpointCategoryId}-${checkpointDetail.checkpointNo}`"
            :label="validationCheckpointLabel + 'はセットで入力してください'"
          />
        </div>
      </div>
      <div class="pega-interview-right-content boss-table-2-item">
        <div class="boss-notice-text">
          貴社求人に応募済type会員のみ公開
        </div>
        <div>記入に迷った場合、例文をご参考ください</div>
        <a
          target="_blank"
          :data-test="`checkpoint-sample-${checkpointCategoryId}`"
          :href="checkpointUrl"
        >例文を見る</a>
      </div>
    </div>
  </template-form>
</template>

<script>
import TemplateForm from '@/components/atoms/TemplateForm'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import { interviewer } from '@/lib/labelValueMappings'
import { mapGetters } from 'vuex'
import _ from 'lodash'
const USER_URL = process.env.USER_ENDPOINT

export default {
  components: {
    TemplateForm,
    ValidationLabel
  },
  props: {
    checkpointCategoryId: {
      type: Number,
      required: true
    },
    checkpointDetails: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      interviewerOptions: interviewer
    }
  },
  computed: {
    userEndPoint: () => USER_URL,
    maxLength () {
      return {
        summary: 100,
        contents: 500
      }
    },
    ...mapGetters({
      interviewCheckpointCategories: 'interviewCheckpointCategoriesMaster'
    }),
    checkpointItemLabel () {
      return this.checkpointCategoryId === 2 ? 'など' : ''
    },
    checkpointRequired () {
      return this.checkpointCategoryId === 1 ? '最低1セット必須' : ''
    },
    checkpointPrefixLabel () {
      return `${this.interviewerOptions.checkpointReasonLabels.find(checkpointReasonLabels => checkpointReasonLabels.id === this.checkpointCategoryId).prefixName}`
    },
    checkpointReasonSuffixLabel () {
      return `${this.interviewerOptions.checkpointReasonLabels.find(checkpointReasonLabels => checkpointReasonLabels.id === this.checkpointCategoryId).suffixName}`
    },
    validationCheckpointLabel () {
      if (this.checkpointCategoryId === 1) {
        return `${this.checkpointCategoryName}の見ているポイント（タイトル）と理由`
      } else if (this.checkpointCategoryId === 2) {
        return `${this.checkpointCategoryName}などの傾向内容（タイトル）と不採用理由`
      } else {
        return `${this.checkpointCategoryName}の質問内容（タイトル）と質問の意図`
      }
    },
    checkpointCategoryName () {
      return `${this.interviewCheckpointCategories.find(checkpointCategory => checkpointCategory.id === this.checkpointCategoryId).name}`
    },
    checkpointUrl () {
      return `${this.userEndPoint}/s/manual/interview/window/sample${this.checkpointCategoryId}.html`
    }
  },
  methods: {
    isInvalidSummary (summary) {
      return summary.length > this.maxLength.summary
    },
    isInvalidContents (contents) {
      return contents.length > this.maxLength.contents
    },
    isInvalidSet (summary, contents) {
      return (_.isEmpty(summary) && !_.isEmpty(contents)) || (!_.isEmpty(summary) && _.isEmpty(contents))
    },
    isInvalid (summary, contents) {
      return this.isInvalidSummary(summary) || this.isInvalidContents(contents) || this.isInvalidSet(summary, contents)
    },
    changed (checkpointCategoryId, checkpointNo, summary, contents) {
      const changedData = {
        checkpointCategoryId: checkpointCategoryId,
        checkpointNo: checkpointNo,
        summary: summary,
        contents: contents,
        isInvalid: this.isInvalid(summary, contents)
      }
      this.$emit('update-checkpoint-details', changedData)
    }
  }
}
</script>
